import React, {useState} from "react"
import {ActionButton} from "../../util/UI/ActionButton";
import {useVerificationRpc} from "../../util/RpcHooks/VerificationRpc";
import {useProviderProfile} from "../../ProviderProfileProvider";
import {EmailOrPhoneLocation, space, VerificationRequest} from "../../provider_api";
import {LabeledTextInput} from "../../components/input/LabeledTextInput";
import {LabeledPhoneInput} from "../../components/input/LabeledPhoneInput";
import ContactMethodType = space.kenko.proto.ContactMethodType;

export const Mobile = () => {

  const verificationRpc = useVerificationRpc();
  const {provider} = useProviderProfile();

  const [verificationCode, setVerificationCode] = useState<string>('');

  const [phone, setPhone] = useState<string>();

  // If they have a phone number, but want to change it, this allows the user
  // to go back to the first step.
  const [isEditingPhone, setIsEditingPhone] = useState(false);

  // If sent, the verification page is shown.
  const [sentOtp, setSentOtp] = useState(false);

  if (!provider?.mobileNumber || isEditingPhone) {
    return <div className={'SurveySection'}>
      <h2>What is your phone number?</h2>

      <LabeledPhoneInput label={''} value={phone} error={''} onChange={setPhone}/>

      <ActionButton rpcState={verificationRpc.rpcState}
                    onClick={() => verificationRpc.send('set_provider_contact_method', new VerificationRequest({
                      type: ContactMethodType.MOBILE_PHONE,
                      location: EmailOrPhoneLocation.PROVIDER,
                      value: phone,
                    }), () => setIsEditingPhone(false))}>Save Number</ActionButton>

      {verificationRpc.rpcState.state == 'error' &&
          <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}

      <div className={'InputHelpText'}>
        By providing your phone number, you agree to receive SMS updates and notifications from Kenko Space LLC (d/b/a
        Kensu). Message and data rates may apply. You can opt out at any time by replying STOP.
      </div>

    </div>
  }

  // There is a mobile number. 
  if (!sentOtp) {
    return <div className={'SurveySection'}>
      <h3>Please confirm your mobile number.</h3>
      <div>We'll send a verification code via SMS to: {provider?.mobileNumber}</div>

      <ActionButton rpcState={verificationRpc.rpcState}
                    onClick={() => verificationRpc.send('send_verification', new VerificationRequest({
                      type: ContactMethodType.MOBILE_PHONE,
                      location: EmailOrPhoneLocation.PROVIDER,
                      value: provider?.mobileNumber,
                    }), () => setSentOtp(true))}>Send</ActionButton>

      <ActionButton secondary smaller onClick={() => setIsEditingPhone(true)}>Use a different phone
        number</ActionButton>

      {verificationRpc.rpcState.state == 'error' &&
          <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}

    </div>
  }


  return <div className={'SurveySection'}>
    <h3>Please enter the verification code you received.</h3>

    <LabeledTextInput
        label={'Verification Code'}
        {...{}}
        inputType={'text'}
        value={verificationCode}
        onChange={v => setVerificationCode(v ?? '')}
    />

    <ActionButton rpcState={verificationRpc.rpcState}
                  onClick={() => verificationRpc.send('check_verification_code', new VerificationRequest({
                    type: ContactMethodType.MOBILE_PHONE,
                    location: EmailOrPhoneLocation.PROVIDER,
                    value: verificationCode,
                  }))}>Verify Number</ActionButton>

    <ActionButton secondary smaller onClick={() => setSentOtp(false)}>Go back</ActionButton>

    {verificationRpc.rpcState.state == 'error' && <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}
  </div>
}